export const DNS_ITEM_DRAG_TYPE = "application/x-dns-item-move";

export const isInternalItemDrag = (dataTransfer) =>
  Boolean(dataTransfer?.types?.includes(DNS_ITEM_DRAG_TYPE));

export const setDragMoveItem = (dataTransfer, item) => {
  dataTransfer.setData(DNS_ITEM_DRAG_TYPE, JSON.stringify(item));
  dataTransfer.effectAllowed = "move";
};

export const parseDragMoveItem = (dataTransfer) => {
  try {
    const raw = dataTransfer.getData(DNS_ITEM_DRAG_TYPE);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/** Collect only real files from a drop (skip OS folders). */
export const getExternalFilesFromDrop = (dataTransfer) => {
  if (!dataTransfer) return [];

  const items = Array.from(dataTransfer.items || []);
  if (items.length > 0) {
    const files = [];
    for (const item of items) {
      if (item.kind !== "file") continue;
      const entry = item.webkitGetAsEntry?.();
      if (entry?.isDirectory) continue;
      const file = item.getAsFile();
      if (file) files.push(file);
    }
    if (files.length > 0) return files;
  }

  return Array.from(dataTransfer.files || []);
};
